import { bindActionCreators } from "redux";
import { connect } from "react-redux";

const mapDispatchToProps = actions => dispatch =>
  bindActionCreators(actions, dispatch);

export default actions => Component =>
  connect(null, mapDispatchToProps(actions))(Component);
